// frontend_choices.js

export const CONTROLLED_PAIN_CHOICES = [
  { value: "0", name: "None - 0" },
  { value: 1, name: "Occasional relieved with medication - 1" },
  { value: 2, name: "Severe - 2" },
  { value: 3, name: "Uncontrollable - 3" },
];

// Used for both Mobility/Standing and Walking
export const MOBILITY_CHOICES = [
  { value: "0", name: "Mobile - 0" },
  { value: 1, name: "Stands with frame/sticks unaided - 1" },
  { value: 2, name: "Frame with assistance from care worker - 2" },
  { value: 3, name: "Immobile/hoist/ 1 care worker - 3" },
  { value: 4, name: "Immobile/hoist/ 2 care workers - 4" },
];

export const SITTING_CHOICES = [
  { value: "0", name: "No assistance required - 0" },
  { value: 1, name: "Minimal assistance required - 1" },
  { value: 2, name: "Requires 1 care worker to assist - 2" },
  { value: 3, name: "Requires 2 care workers to assist - 3" },
];

export const MOVEMENT_IN_BED_CHOICES = [
  { value: "0", name: "Free movement - 0" },
  { value: 1, name: "Requires 1 care worker to assist - 1" },
  { value: 2, name: "Requires 2 care workers to assist - 2" },
  { value: 3, name: "Immobile/hoist/ 2 care workers - 3" },
];

export const TOILETING_CHOICES = [
  { value: "0", name: "Mobile - 0" },
  { value: 1, name: "Mobile catheterised - 1" },
  { value: 2, name: "Requires 1 care worker to assist - 2" },
  { value: 3, name: "Requires 2 care workers to assist - 3" },
  { value: 4, name: "Immobile/needs hoist/continence issues - 4" },
];

export const BATHING_CHOICES = [
  { value: "0", name: "Mobile - 0" },
  { value: 1, name: "Baths on own using home aid - 1" },
  { value: 2, name: "Requires 1 care worker to assist - 2" },
  { value: 3, name: "Requires 2 care workers to assist - 3" },
  { value: 4, name: "Specialist equipment and 2 care workers required - 4" },
];

export const SKIN_CONDITION_CHOICES = [
  { value: "0", name: "No problems - 0" },
  { value: 1, name: "At risk - 1" },
  { value: 2, name: "Poor/not broken - 2" },
  { value: 3, name: "Poor/broken - 3" },
];

export const initialFormData = {
  care_plan: "",
  comments: "",
};

export const capabilityRiskLevels = [
  {
    label: "Low Dependency",
    scoreRange: "0-6",
    description:
      "Client is largely independent and requires minimal or no assistance. Care needs are low, and the risk of complications is minimal.",
  },
  {
    label: "Moderate Dependency",
    scoreRange: "7-13",
    description:
      "Client requires some assistance with daily activities. May need help from one care worker and use mobility aids. A structured care plan is necessary.",
  },
  {
    label: "High Dependency",
    scoreRange: "14-20",
    description:
      "Client requires significant daily assistance, often involving two care workers for mobility and personal care. At higher risk for complications like skin breakdown.",
  },
  {
    label: "Very High Dependency",
    scoreRange: "21-28",
    description:
      "Client is fully dependent on care workers for most or all daily needs. Likely immobile and requires specialist equipment. A comprehensive care plan and close monitoring are essential.",
  },
];
